import { Link } from "@tanstack/react-router";

/**
 * Maillage interne automatique vers le hub de tête /reportage-corse.
 * (/corse-reportage, son ancien doublon territorial, porte désormais un
 * canonical vers /reportage-corse : on ne lie plus que la page principale.)
 * Les ancres tournent de façon déterministe selon la page d'origine afin
 * d'éviter une ancre unique répétée sur tout le site.
 */

const EDITORIAL_ANCHORS = [
  "Tous les reportages sur la Corse",
  "Reportage Corse : le catalogue complet",
  "Reportages corses : enquêtes, histoire et société",
  "Voir tous les reportages corses vérifiés",
  "Corse reportage : par région et micro-région",
  "Reportages en Corse, région par région",
  "Corse reportage : Bastia, Ajaccio, Balagne, Centre-Corse",
  "Explorer les reportages par territoire corse",
];

function hash(input: string) {
  let h = 0;
  for (let i = 0; i < input.length; i++) h = (h * 31 + input.charCodeAt(i)) >>> 0;
  return h;
}

export function ReportageHubLinks({
  contextKey,
  contextLabel,
  className = "mt-10 border-t border-border pt-8",
}: {
  /** Identifiant stable de la page source (slug) : fixe la variante d'ancre. */
  contextKey: string;
  /** Sujet de la page source, réutilisé dans le texte d'accroche. */
  contextLabel?: string;
  className?: string;
}) {
  const i = hash(contextKey);
  const editorial = EDITORIAL_ANCHORS[i % EDITORIAL_ANCHORS.length]!;
  const subject = contextLabel ? `« ${contextLabel} »` : "ce sujet";

  return (
    <section className={className} aria-labelledby="hub-reportage-corse">
      <h2
        id="hub-reportage-corse"
        className="font-[family-name:var(--font-display)] text-2xl"
      >
        Continuer avec le grand sommaire
      </h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Au-delà de {subject}, le sommaire de référence du catalogue Corse TV,
        classé par angle éditorial et par territoire.
      </p>
      <ul className="mt-5 grid gap-3">
        <li>
          <Link
            to={"/reportage-corse" as never}
            className="block rounded-xl border border-border bg-card p-4 transition-colors hover:border-foreground"
          >
            <span className="text-[0.6rem] uppercase tracking-[0.25em] text-muted-foreground">
              Sommaire de référence
            </span>
            <span className="mt-1 block font-medium">{editorial}</span>
            <span className="mt-1 block text-sm text-muted-foreground">
              Enquêtes et justice, histoire et mémoire, société, montagne et littoral,
              culture et langue corse — Bastia et Cap Corse, Ajaccio et Extrême-Sud,
              Balagne, Centre-Corse, plaine orientale.
            </span>
          </Link>
        </li>
      </ul>
    </section>
  );
}
